// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Container_container__1TWoz {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Accueil/Container.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Container_container__1TWoz"
};
export default ___CSS_LOADER_EXPORT___;
